import { Logout } from '../../pages/Settings';
import { ApiKeys } from '../../pages';
import { useStores } from '../../stores';
import React from 'react';

const ApiKeysContainer = ({ closeModal }) => {
	return <ApiKeys closeModal={closeModal} />;
};

export default ApiKeysContainer;
